function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 .574h9.947v7.921H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.725 5.752C2.775 4.583 5.307 2.127 8 2.127c.211 0 .42.038.628.067L9.948.877A6.68 6.68 0 008 .574c-3.547 0-6.574 3.114-7.755 4.51a1.03 1.03 0 000 1.335c.45.532 1.17 1.314 2.082 2.077l1.108-1.108a15.924 15.924 0 01-1.71-1.636",
  fill: "#000",
  mask: "url(#mask-2)",
  transform: "translate(0 2.497)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M7.673.007L6.566 1.114a16.02 16.02 0 011.71 1.637C7.225 3.92 4.694 6.375 2 6.375c-.211 0-.42-.039-.628-.067l-1.32 1.32c.625.19 1.277.301 1.948.301 3.548 0 6.574-3.113 7.755-4.51a1.028 1.028 0 000-1.334A17.314 17.314 0 007.673.007",
  fill: "#000",
  mask: "url(#mask-4)",
  transform: "translate(6 5.497)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13.834 1.291a.834.834 0 01.637.238c.341.342.313.924-.063 1.3L11.41 5.825 10.178 7.06 7.06 10.178l-.806.806L5.137 12.1 2.83 14.408c-.188.188-.429.289-.663.3a.836.836 0 01-.638-.237c-.341-.342-.313-.924.063-1.3l1.954-1.954 1.043-1.043L5.822 8.94l5.041-5.04 2.307-2.309c.19-.188.429-.289.664-.3z",
  fill: "#000"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default SvgComponent;